import { Button, Card, Col, Flex, Row, Space } from "antd";
import { MainLayout } from "components/layouts";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

const NewsView = ({
    viewNews = () => { },
    moreNews = () => { }
}) => {

    const { t } = useTranslation();
    const location = useLocation()
    const navigate = useNavigate();

    console.log("location", location);


    return (
        <MainLayout
            breadcrumb={[
                { title: t("home.header"), link: "/" },
                { title: t("news.header") },
                { title: t("news_list.header"), link: "/news_list" },
            ]}
            title={t("news.header")}
        >
            <Space direction="vertical" size={24} style={{ width: '100%' }}>
                <Button type="default" style={{ height: "36px" }} onClick={() => navigate(-1)}>
                    <Flex gap={5} style={{
                        placeItems: 'center'
                    }}>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.8334 9.99996H4.16669M4.16669 9.99996L10 15.8333M4.16669 9.99996L10 4.16663" stroke="#667085" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <span style={{ color: "#667085" }}>{t('common.back')}</span>
                    </Flex>
                </Button>
                <Card style={{ borderRadius: "20px" }}>

                    <Flex>
                        <Col span={18}>
                            {viewNews(location.state)}
                        </Col>
                        <Col span={6}>
                            {moreNews()}
                        </Col>
                    </Flex>
                </Card>
            </Space>
        </MainLayout>
    )
}

export default NewsView;